// extracted by mini-css-extract-plugin
module.exports = {"basket":"_baeb6c","icon":"_69df45","disabled":"_fdcf3f","compareButton":"_787328"};